<!--
 * @Description:
 * @Author: git config user.name
 * @Date: 2025-09-09 09:17:54
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-09-15 09:01:20
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\feedBack\index.vue
-->
<template>
  <div class="h100">
    <filter-layout @search="search" @reset="reset" hasHeader>
      <template #header>
        <el-tabs v-model="activeTab" @tab-click="tabChange(activeTab)">
          <el-tab-pane name="0">
            <span slot="label">待处理 </span>
          </el-tab-pane>
          <el-tab-pane name="1">
            <span slot="label">已处理 </span>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template #filter>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchRef"
          :model="searchForm"
          label-width="90px"
        >
          <el-form-item label="反馈详情">
            <el-input
              v-model="searchForm.remark"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="创建人">
            <el-input
              v-model="searchForm.createUser"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择"
              clearable
              multiple
            >
              <el-option
                :value="-1"
                label="未处理"
                v-if="activeTab == 0"
              ></el-option>
              <el-option
                :value="0"
                label="处理中"
                v-if="activeTab == 0"
              ></el-option>
              <el-option
                :value="1"
                label="已解决"
                v-if="activeTab == 1"
              ></el-option>
              <el-option
                :value="2"
                label="已关闭"
                v-if="activeTab == 1"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template #content>
        <div class="w-table-layout w-table-page pdt10">
          <div class="w-table-content">
            <el-table
              :data="filiterData"
              height="100%"
              highlight-current-row
              row-key="id"
              border
              ref="table"
            >
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="70"
              ></el-table-column>
              <el-table-column
                prop="remark"
                label="反馈详情"
                header-align="center"
                min-width="200"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="linkman"
                label="联系人"
                align="center"
                width="140"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="联系人电话"
                align="center"
                width="140"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="otherLink"
                label="其他联系方式"
                align="center"
                width="140"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="linkman"
                label="创建人"
                align="center"
                width="140"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="createDate"
                label="创建时间"
                align="center"
                width="140"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="status"
                label="状态"
                width="150"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="orange" v-if="scope.row.status == -1">
                    待处理
                  </span>
                  <span class="green" v-else-if="scope.row.status == 0"
                    >处理中</span
                  >
                  <span class="red" v-else-if="scope.row.status == 1"
                    >已解决</span
                  >
                  <span class="red" v-else-if="scope.row.status == 2"
                    >已关闭</span
                  >
                </template>
              </el-table-column>
              <el-table-column align="left" width="200">
                <template slot="header">操作</template>
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    @click="changeBtn(scope.row, 'view')"
                  >
                    <svg-icon icon-class="form-look"></svg-icon> 查看
                  </el-button>
                  <el-button
                    type="success"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    @click="changeBtn(scope.row, 'check')"
                    v-if="scope.row.status == -1 || scope.row.status == 0"
                  >
                    <svg-icon icon-class="form-examine"></svg-icon> 处理
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="w-table-footer">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageConfig.currentPage"
              :page-sizes="pageConfig.pageList"
              :page-size="pageConfig.pageSize"
              :total="pageConfig.total"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </filter-layout>
    <viewDialog ref="viewDialog" @change="search"></viewDialog>
  </div>
</template>
<script>
import * as API from "@/api/modules/feedBack";

import viewDialog from "./components/view-dialog.vue";

export default {
  components: { viewDialog },
  data() {
    return {
      activeTab: 0,
      searchForm: {
        remark: "",
        createUser: "",
        status: [],
      },
      pageConfig: {
        currentPage: 1, // 当前页码
        pageList: [10, 20, 50, 100], // 显示条数数组
        pageSize: 10, // 当前显示条数
        total: 0, // 当前总条数
      },
      filiterData: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    //查询
    search() {
      this.pageConfig.pageSize = 10;
      this.pageConfig.currentPage = 1;
      this.getData();
    },
    //重置
    reset() {
      this.searchForm = {
        remark: "",
        createUser: "",
        status: [],
      };
      this.pageConfig.pageSize = 10;
      this.pageConfig.currentPage = 1;
      this.getData();
    },
    tabChange(val) {
      this.activeTab = val;
      this.searchForm = {
        remark: "",
        createUser: "",
        status: [],
      };
      this.search();
    },
    //获取列表数据
    getData() {
      let params = {
        current: this.pageConfig.currentPage,
        size: this.pageConfig.pageSize,
        remark: this.searchForm.remark,
        createUser: this.searchForm.createUser,
        tabFlag: this.activeTab,
        status: this.searchForm.status,
      };
      API.getPlatSuggestPage(params)
        .then((res) => {
          this.filiterData = res.data.records;
          this.pageConfig.total = parseInt(res.data.total);
        })
        .catch(() => {});
    },
    // 切换显示条数
    handleSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.getData();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val;
      this.getData();
    },
    changeBtn(row, type) {
      switch (type) {
        case "view":
          this.$refs.viewDialog.open('view',row);
          break;
        case "check":
          this.$refs.viewDialog.open('check',row);
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
</style>
